module.exports = __webpack_public_path__ + "static/media/sadRobot.00c18a87.png";